import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { messageList, messageDetail } from '@/api/notice.js';
import messageDetailModel from '../message/messageDetailModel.vue';
import { mapState } from 'vuex';
import { analyzVariable } from '../message/util';
export default {
  components: {
    messageDetailModel
  },
  data() {
    return {
      allMessageList: [],
      unreadMessageList: [],
      visible: false,
      allMessageTotal: 0,
      unreadMessageTotal: 0,
      isLoading: false,
      messageDetailData: {},
      activeKey: '1'
    };
  },
  created() {
    this.getAllMessageList();
  },
  props: {
    messageDetailModel: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      hasUnReadMessage: state => state.message.hasUnReadMessage
    })
  },
  watch: {
    visible(val) {
      if (val) {
        this.activeKey = '1';
        this.allMessageList = [];
        this.unreadMessageList = [];
        this.getAllMessageList();
      } else {
        this.activeKey = '';
      }
    }
  },
  methods: {
    getAllMessageList() {
      let readParams = {
        page: 1,
        pageSize: 10
      };
      let unreadParams = {
        page: 1,
        pageSize: 10,
        readingStatus: '0'
      };
      messageList(readParams).then(res => {
        this.allMessageList = res.items.map(item => {
          item.content = item.content.replace(/<[^>]+>/g, '');
          item.content = analyzVariable(item.content);
          return item;
        });
        // .map(item => {
        //   item.content = '<a class="variable-message-class" href=/#/policy/homeManage/policyInfo/38967>任务列表</a>';
        //   return item;
        // });
        this.allMessageTotal = res.totalNum;
      });
      messageList(unreadParams).then(res => {
        this.unreadMessageList = res.items.map(item => {
          item.content = item.content.replace(/<[^>]+>/g, '');
          item.content = analyzVariable(item.content);
          return item;
        });
        this.unreadMessageTotal = Number(res.totalNum);
      });
    },
    toDetail(item) {
      this.isLoading = true;
      messageDetail({
        messageDetailId: item.id
      }).then(res => {
        this.messageDetailData = res;
        this.$store.dispatch('message/getUnReadCount');
        this.$store.commit('message/SET_CURRENT_PAGE', 1);
        this.$store.commit('message/readMessage', item.id);
      }).finally(() => {
        this.visible = false;
        this.isLoading = false;
      });
    },
    seeMore(key) {
      this.$router.push({
        name: 'messageCenter',
        params: {
          tabKey: key
        }
      });
      this.visible = false;
    }
  }
};